import { combineReducers } from 'redux'
import userStates from './user_states';

const allReducers = combineReducers({
    signIn: userStates
  })

  export default allReducers;